import { useMemo } from 'react';
import type { VoidFunctionComponent } from 'react';

import { DetailsPanelList } from '../../generic/DetailsPanel';

import type { DependencySummaryData } from './types';

import styles from './DependencySummary.module.less';

type Props = {
  summary: DependencySummaryData;
};

/**
 * The Dependency Summary component used in multiple modals
 */
const DependencySummary: VoidFunctionComponent<Props> = ({ summary }) => {
  const rows = useMemo(() => {
    return [
      {
        label: 'Name',
        content: (
          <span>
            {summary.packageName}
          </span>
        ),
      },
      {
        label: 'Version',
        content: (
          <span>
            {summary.revision}
          </span>
        ),
      },
      {
        label: 'Locator',
        content: (
          <span>
            {summary.locator}
          </span>
        ),
      },
    ];
  }, [summary]);

  return (
    <div className={styles.dependencySummaryPanelList}>
      <DetailsPanelList rows={rows} />
    </div>
  );
};

export default DependencySummary;
